import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      identifier: 'profile/goPay/identifier',
      questionTariff: 'profile/goPay/questionTariff',
      backendPaymentMethodGroups: 'profile/goPay/backendPaymentMethodGroups'
    })
  },
  methods: {
    ...mapActions({
      setDialogLoading: 'profile/goPay/setDialogLoading',
      setIdentifier: 'profile/goPay/setIdentifier',
      setQuestionTariff: 'profile/goPay/setQuestionTariff',
      setBackendPaymentMethodGroups: 'profile/goPay/setBackendPaymentMethodGroups',
      setGoPayId: 'profile/goPay/setGoPayId'
    }),
    getAvailableTariffs() {
      this.setDialogLoading(true);
      return this.$http
        .get(`/v1/questionTariffs/byQuestion/${this.identifier}`)
        .then(data => {
          if (Array.isArray(data) && data.length === 1) {
            this.setQuestionTariff(data[0]);
            return this.getPaymentMethods();
          }
        })
        .catch(err => {
          this.setDialogLoading(false);
          this.handleError({ error: err, code: '0x00000032' });
        });
    },

    getPaymentMethods() {
      return this.$http
        .get(`/v1/paymentMethods/byQuestionAndCategory/${this.identifier}`)
        .then(data => {
          this.setBackendPaymentMethodGroups(data);
        })
        .catch(err => {
          this.handleError({ error: err, code: '0x00000034' });
        })
        .finally(() => this.setDialogLoading(false));
    }
  }
};
